export enum FactoryNodeInterfaceParameterType {
    Number = "Number",
    String = "String",
    Boolean = "Boolean",
    Date = "Date",
}